const TEXTS = {
  tabTitle: 'Chat Suggestions',
  tabSubtitle:
    'Predefined prompts offered to users in the Clive chat. The prompt text is sent to Clive and never shown to chat users.',
  addPrompt: 'Add prompt',
  createPrompt: 'Add chat suggestion',
  editPrompt: 'Edit chat suggestion',
  columns: {
    key: 'Key',
    title: 'Title',
    text: 'Prompt text',
    edit: 'Edit',
    delete: 'Delete',
  },
  fields: {
    key: 'Key',
    keyHelper: 'Generated from the title. Cannot be changed later.',
    title: 'Title',
    text: 'Prompt text',
  },
  validation: {
    toastTitle: 'Please fix the following errors',
    keyRequired: 'The title must contain letters or digits to generate a key',
    keyFormat: 'The key generated from the title may only use English letters, digits and underscores',
    keyDuplicate: 'A prompt with this key already exists',
    titleRequired: 'Title is required',
    textRequired: 'Prompt text is required',
  },
  emptyState: {
    title: 'No chat suggestions',
    subtitle: 'Add the first predefined prompt for this organization.',
  },
  deleteConfirm: {
    title: 'Delete chat suggestion',
    body: (name: string) => `Delete "${name}"? Users will no longer see it in the Clive chat.`,
    primary: 'Delete',
    secondary: 'Cancel',
  },
};

export default TEXTS;
